import { FunnelSimple, Heart, List, MagnifyingGlass, Plus } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';

import { IframeOverlay } from 'external-quote/components';
import { externalQuoteTheme } from 'external-quote/styles';
import { IPartBom } from 'partBoms/types';

import {
  ActionButton,
  BOMConfiguratorButton,
  FilterButton,
  GPValue,
  LeftSection,
  PriceInfo,
  PriceLabel,
  PriceValue,
  QuantityInput,
  RightSection,
  SearchContainer,
  SearchInput,
} from './styles';

interface IProps {
  onAddItems: (partBom: IPartBom) => void;
  partBomId: number | null;
  onCloseIframe?: () => void;
}

export const SearchBar = ({ onAddItems, partBomId, onCloseIframe }: IProps) => {
  const [isAddNewOpen, setIsAddNewOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);

  useEffect(() => {
    if (partBomId) {
      setIsViewOpen(true);
    } else {
      setIsViewOpen(false);
    }
  }, [partBomId]);

  return (
    <SearchContainer>
      <LeftSection>
        <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>Quantity *</span>
        <QuantityInput type="number" defaultValue="1" />

        <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>
          Search: Prod# or Desc. *
        </span>
        <SearchInput placeholder="Search by Prod#" />
        <button style={{ padding: '2px', border: 'none', background: 'none', cursor: 'pointer' }}>
          <MagnifyingGlass size={14} />
        </button>

        <ActionButton>
          <Plus size={14} />
          Non Trade Item
        </ActionButton>

        <BOMConfiguratorButton onClick={() => setIsAddNewOpen(true)}>
          <List size={14} />
          BOM Configurator
        </BOMConfiguratorButton>

        <ActionButton>
          <Plus size={14} />
          Advance Search
        </ActionButton>
      </LeftSection>

      <RightSection>
        <PriceInfo>
          <PriceLabel>Total Sell price :</PriceLabel>
          <PriceValue>$1,936,023.05</PriceValue>
          <PriceLabel>GP% :</PriceLabel>
          <GPValue>16.67</GPValue>
          <Heart size={14} weight="fill" color={externalQuoteTheme.colors.warningOrange} />
        </PriceInfo>

        <FilterButton>
          <FunnelSimple size={14} />
        </FilterButton>
      </RightSection>

      {isAddNewOpen && (
        <IframeOverlay
          src="/v2/iframe/part-bom/add"
          onClose={() => setIsAddNewOpen(false)}
          onAddItems={onAddItems}
        />
      )}

      {isViewOpen && partBomId && (
        <IframeOverlay
          src={`/v2/iframe/part-bom/add?id=${partBomId}`}
          onClose={() => {
            setIsViewOpen(false);
            onCloseIframe?.();
          }}
          onAddItems={onAddItems}
        />
      )}
    </SearchContainer>
  );
};
